import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import { connect } from 'react-redux';
import { track } from '../../tracking/trackingActionCreators';
import { withRouter } from '../../../withRouter';

function scrollToApps() {
    document.querySelector('div[name=egnyte-apps]').scrollIntoView({ behavior: 'smooth' });
}

const Banners = (props) => {
    if (!props.banners) {
        return null;
    }

    const customBannerClick = () => {
        props.dispatchTracking('bannerCustom');
        // depending on props...
        if (props.banners.bannerAppId) {
            props.history.push(`/apps/${props.banners.bannerAppId}`);
        }
    };
    const appsBannerClick = () => {
        props.dispatchTracking('bannerApps');
        scrollToApps();
    };

    return (
        <div className="appsListBanners">
            <div className="appsListBanners-banner banner-egnyteApps" onClick={appsBannerClick}>
                <MediaQuery query="(min-width: 1340px)">
                    <img src={props.banners.egappsUrlBig} />
                </MediaQuery>
                <MediaQuery query="(max-width: 1339px)">
                    <img src={props.banners.egappsUrlSmall} />
                </MediaQuery>
            </div>
            <div className="appsListBanners-banner" onClick={customBannerClick}>
                <MediaQuery query="(min-width: 1340px)">
                    <img src={props.banners.bannerUrlBig} />
                </MediaQuery>
                <MediaQuery query="(max-width: 1339px)">
                    <img src={props.banners.bannerUrlSmall} />
                </MediaQuery>
            </div>
        </div>
    );
};

Banners.propTypes = {
    banners: PropTypes.shape({
        bannerAppId: PropTypes.string,
        bannerUrlBig: PropTypes.string,
        bannerUrlSmall: PropTypes.string,
        egappsUrlBig: PropTypes.string,
        egappsUrlSmall: PropTypes.string,
    }),
    dispatchTracking: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
};

const mapDispatchToProps = {
    dispatchTracking: track,
};

const mapStateToProps = (state) => ({ banners: state.user.banners });

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Banners));
